import React, { Component } from "react";
import dotenv from 'dotenv';
import Helper from '../../Devices/DevServices/Helper'
import { Redirect } from 'react-router-dom';
import { connect } from "react-redux";
import { compose } from "redux";
import { 
    //thunkTest,
    update_state_item,
    t_get_all_projects,
    t_get_project_desks_by_user_and_project_id,
    t_get_devlist_by_desk_id_and_user_id,
    t_get_sensorlist_by_desk_id_and_user_id,
    t_graph_update_graph_selectedDate_by_devId_and_sensorId,
    t_graph_update_graph_field_prop_by_devId_and_sensorId,
    t_update_request_graph_by_devId_and_sensorId,
    t_update_request_graph_rx_data,
    update_modal_chart,
} from "../../reducers/dev";

import { Card, Button, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import DevList from "./DevList"
import SensorList from "./SensorList"
import ModalChart from "../../Devices/DevServices/ModalChart"

//import "./selecteddesk.css"

///run/user/1000/gvfs/sftp:host=xtal.asia,user=venus/home/venus/docker/4028-29-30_wifi_api_react/app/frontend/src/Devices/DevServices/Chart.jsx

dotenv.config();

class PageSelectedDesk extends Component {

/*   constructor(props) {
    super(props);
    this.handlelocationId = this.handlelocationId.bind(this);
    this.onChangelocationId= this.onChangelocationId.bind(this);

    this.state = {
      //locationId: 0,
      isValidate: false,
      loading: false,
    };
  } */

  componentWillUnmount(){
    //console.log('Good Bye!')
/*     this.props.reset_LocIdInfo() */
    this.props.update_state_item('selected_desk', {})
  }
  
  componentDidMount(){
    const rx_desk_id = this.props.match.params.desk_id
    this.props.update_state_item('selected_desk_id', rx_desk_id)
    //get data for this desk
    //console.log('PageSelectedDesk: ', rx_desk_id)
    this.props.t_get_devlist_by_desk_id_and_user_id()
    this.props.t_get_sensorlist_by_desk_id_and_user_id()

    // Set up the interval to fetch data every 5 seconds
    this.interval = setInterval(() => {
      this.props.t_get_devlist_by_desk_id_and_user_id()
      this.props.t_get_sensorlist_by_desk_id_and_user_id()
      //console.log('PageSelectedDesk. Refresh data timer. 2min')
    }, this.props.dev.refreshDataTime*24);  //2min
/*   this.interval = setInterval(() => {
        //this.props.t_get_devlist_by_desk_id_and_user_id(rx_desk_id)
        //this.props.t_get_sensorlist_by_desk_id_and_user_id(rx_desk_id)
        window.location.reload();
        console.log('PageSelectedDesk. Refresh data timer. 5s')
      }, this.props.dev.refreshDataTime*24); //5s*12 = 60s */
  } 


  render() {
    // Check if the user is authenticated or exists
    if (!this.props.user) {
      // Redirect to an external URL
      //window.location.href = "https://google.com";
      window.location.href = process.env.REACT_APP_HOST+"/login";
      return null; // Return null to avoid rendering anything else
    }
    //Get Projects by user_role
    

    return (
    <div className="">
      {/* <p>look: {this.props.dev.clickedMenu}</p> */}
{/*     <h4 className="text-secondary">Selected Project: <span className="text-primary" >{this.props.dev?.selected_project_desks?.projectName}</span></h4>
    
    {DevsExample(this.props.dev.selected_project_desks.desks)} */}


      <DevList data = {this.props.dev.selected_desk}
      isLoading = {this.props.dev.isLoading}
      />

      <SensorList 
      data = {this.props.dev.selected_desk_sensorList}
      t_graph_update_graph_selectedDate_by_devId_and_sensorId={this.props.t_graph_update_graph_selectedDate_by_devId_and_sensorId}
      t_graph_update_graph_field_prop_by_devId_and_sensorId = {this.props.t_graph_update_graph_field_prop_by_devId_and_sensorId}
      t_update_request_graph_by_devId_and_sensorId = {this.props.t_update_request_graph_by_devId_and_sensorId} 
      t_update_request_graph_rx_data = {this.props.t_update_request_graph_rx_data} 
      />
      
      <ModalChart 
            update_modal_chart = {this.props.update_modal_chart}
            isModal={this.props.dev.modalChart.isModal}
            modalTitle = {this.props.dev.modalChart.modalTitle}
            sensor_data_for_modal = {this.props.dev.request_graph_by_sensor.rx_data_by_date.rows}
            />


      <Helper props={this.props.dev} />
      
    </div>
    );
  }
}

function mapStateToProps(state) {
  //console.log(state)
  const { user, test } = state.auth;

  return {
    user,
    test,
    dev: state.dev,
/*    location: state.location */
  };
}

  const mapDispatchToProps = { 
    //thunkTest,
    update_state_item,
    t_get_all_projects,
    t_get_project_desks_by_user_and_project_id,
    t_get_devlist_by_desk_id_and_user_id,
    t_get_sensorlist_by_desk_id_and_user_id,
    t_graph_update_graph_selectedDate_by_devId_and_sensorId,
    t_graph_update_graph_field_prop_by_devId_and_sensorId,
    t_update_request_graph_by_devId_and_sensorId,
    t_update_request_graph_rx_data,
    update_modal_chart,
  }



export default compose(
  connect(mapStateToProps, mapDispatchToProps)
  //withAuthRedirect
)(PageSelectedDesk);


